<div [@pageTransition]>
    <p>profile works!</p>
</div>
